var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemperatureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_122",
    "data-name": "Group 122",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_139",
    "data-name": "Rectangle 139",
    width: 140,
    height: 140,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M70,0A70,70,0,1,1,0,70,70,70,0,0,1,70,0",
    fill: "#1a1818",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M53.931,72.735C48.113,75.815,43.286,83.3,43.286,90.308c0,5.808.838,8.875,3.936,13.458a22.9,22.9,0,0,0,8.306,6.954,21.481,21.481,0,0,0,24.349-4.393c10.162-10.156,7.178-27.148-4.659-33.415V38.3c.016-6.373-4.622-11-9.934-11-4.584,0-7.563,1.573-9.9,5.179a9.842,9.842,0,0,0-1.453,5.47Zm5.322,3.372V39.363c-.011-2.989.62-4.831,2.955-6.1a5.386,5.386,0,0,1,6.587,1.344c1.07,1.149,1.286,2.736,1.28,4.932V76.284c2.642,1.4,4.6,1.855,7.1,5.145a16.081,16.081,0,0,1,.566,19.035c-6.594,9.858-22.639,9.039-27.765-2.827A16.242,16.242,0,0,1,57.3,76.991c.633-.329,1.336-.555,1.955-.884",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M62.092,78.237c-3.964.331-8.083,4.064-9.757,7.81a13.338,13.338,0,0,0,2.073,13.9,11.338,11.338,0,0,0,2.484,2.309C67.135,109.767,82.267,99.22,77.021,86.2c-1.486-3.69-5.857-7.635-9.785-7.961l0-18.106c.009-1.583-.26-3.549-2.486-3.549a2.623,2.623,0,0,0-2.066.95c-.984,1.227-.594,6.156-.594,8.457Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M82.847,40.606H94.379c3.063,0,3.063-5.325,0-5.325H83.024A2.9,2.9,0,0,0,80.583,37.8c-.112,1.217,1.115,2.807,2.264,2.807",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M83.024,51.256H94.378a2.692,2.692,0,0,0-.177-5.324H83.024c-3.055,0-3.191,5.324,0,5.324",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M83.024,61.907H94.378c1.222,0,2.306-1.117,2.306-2.84A2.92,2.92,0,0,0,94.2,56.581H83.024c-3.055,0-3.191,5.326,0,5.326",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M85.686,72.556h8.693a2.414,2.414,0,0,0,1.563-.742c1.685-1.576.358-4.582-1.563-4.582H85.686c-3.017,0-3.255,5.324,0,5.324",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperatureIcon);
export default __webpack_public_path__ + "static/media/temperature-icon.cf50e9cac1fd61dd6e403cf6c0b092b2.svg";
export { ForwardRef as ReactComponent };